import { baseUrl, headers, jwtHeaders, logoutUtil } from '../common/data';

export const fetchOverviewData=async(id)=>{
    const response =await fetch(`${baseUrl}/api/dashboard/overview/${id}`,{
        method: 'GET',
        headers: jwtHeaders()
    });
    const resData=await response.json();
    return resData
}